import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import "./CompleteProfileBio.scss";

const CompleteProfileBio: React.FC = () => {
  let [wordCount, setWordCount] = useState(0);
  let [isChecked, updateCheck] = useState(true);
  const navigate = useNavigate();

  const Check = () => {
    updateCheck(!isChecked);
    console.log(isChecked);
  };

  const updateCount = (text: any) => {
    setWordCount(text.length);
  };

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    register,
  } = useForm({});

  const onSubmit = (data: any) => {
    console.log(data);
    navigate("/sign-up/years");
  };

  return (
    <>
      {/* <div className="sign-up-bio__caption">
        <p className="sign-up-bio__caption-title">Personal Bio</p>
        <p className="sign-up-bio__caption-subtitle">
          Let us know a bit about you with a short presentation
        </p>
      </div>

      <form className="sign-up-bio__input" onSubmit={handleSubmit(onSubmit)}>
        <AcedTextArea
          placeHolder="Short bio"
          control={control}
          value={control._formValues.code}
          register={register("bio")}
          onChangeText={updateCount}
          className="text-area"
        ></AcedTextArea>
        <p>{wordCount}/200</p>

        <Button className="btn btn-primary ">Confirm</Button>
      </form> */}
    </>
  );
};

export default CompleteProfileBio;
